import { z } from "zod";
import {
  ftthOrchestrator,
  mobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const digitalWalletResponseFtth = ftthOrchestrator.extend({
  payload: z.object({
    id: z.string(),
    type: z.literal("REGISTER"),
    // status: z.literal("NEW"),
    transactionTimestamp: z.string(),
    transactionType: z.literal("ALL_IN_ONE"),
    orderId: z.string(),
    beneficiary: z
      .object({
        referredType: z.string().optional(),
        email: z.string().optional(),
        id: z.string().optional(),
        phoneNumber: z.string().optional(),
      })
      .optional(),
    // channel: z.object({
    //   id: z.literal("WEB"),
    //   name: z.literal("WEB"),
    // }),
    payer: z.object({
      id: z.string(),
    }),
    paymentMethod: z.object({
      // action: z.literal("REGISTER"),
      // mode: z.literal("PRIMARY"),
      methodType: z.literal("DIGITAL_WALLET"),
    }),
  }),
});

export const creditCardResponseFtth = ftthOrchestrator.extend({
  payload: z.object({
    id: z.string(),
    type: z.literal("REGISTER"),
    // status: z.literal("PENDING"),
    transactionLink: z.string().optional(),
    transactionTimestamp: z.string(),
    transactionType: z.literal("ALL_IN_ONE"),
    orderId: z.string(),
    beneficiary: z
      .object({
        referredType: z.string().optional(),
        email: z.string().optional(),
        id: z.string().optional(),
        phoneNumber: z.string().optional(),
      })
      .optional(),
    // channel: z.object({
    //   id: z.literal("WEB"),
    //   name: z.literal("WEB"),
    // }),
    payer: z.object({
      id: z.string(),
    }),
    paymentMethod: z.object({
      // action: z.literal("REGISTER_EXCLUSIVE"),
      // mode: z.literal("PRIMARY"),
      methodType: z.literal("CREDIT_CARD"),
    }),
    // paymentItem: z.array(z.any()),
  }),
});

export const digitalWalletResponseMobile = mobileOrchestrator.extend({
  payload: z.object({
    id: z.string(),
    type: z.literal("REGISTER"),
    // status: z.literal("NEW"),
    transactionTimestamp: z.string(),
    transactionType: z.literal("ALL_IN_ONE"),
    orderId: z.string(),
    beneficiary: z
      .object({
        referredType: z.string().optional(),
        email: z.string().optional(),
        id: z.string().optional(),
        phoneNumber: z.string().optional(),
      })
      .optional(),
    // channel: z.object({
    //   id: z.literal("WEB"),
    //   name: z.literal("WEB"),
    // }),
    payer: z.object({
      id: z.string(),
    }),
    paymentMethod: z.object({
      // action: z.literal("REGISTER"),
      // mode: z.literal("PRIMARY"),
      methodType: z.literal("DIGITAL_WALLET"),
    }),
  }),
});

export const creditCardResponseMobile = mobileOrchestrator.extend({
  payload: z.object({
    id: z.string(),
    type: z.literal("REGISTER"),
    // status: z.literal("PENDING"),
    transactionLink: z.string().optional(),
    transactionTimestamp: z.string(),
    transactionType: z.literal("ALL_IN_ONE"),
    orderId: z.string(),
    beneficiary: z
      .object({
        referredType: z.string().optional(),
        email: z.string().optional(),
        id: z.string().optional(),
        phoneNumber: z.string().optional(),
      })
      .optional(),
    // channel: z.object({
    //   id: z.literal("WEB"),
    //   name: z.literal("WEB"),
    // }),
    payer: z.object({
      id: z.string(),
    }),
    paymentMethod: z.object({
      // action: z.literal("REGISTER_EXCLUSIVE"),
      // mode: z.literal("PRIMARY"),
      methodType: z.literal("CREDIT_CARD"),
    }),
    // paymentItem: z.array(z.any()),
  }),
});

export const serverResponse = z.union([
  digitalWalletResponseFtth,
  creditCardResponseFtth,
  digitalWalletResponseMobile,
  creditCardResponseMobile,
]);
